import { ScheduleRelationshipTypeBase } from './base/schedule-relationship-type-base';

export class ScheduleRelationshipType extends ScheduleRelationshipTypeBase { }